import * as React from "react";
import { attributeMap } from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/AttributeMap/AttributeMap";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import DreamAttributeIcons from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/DreamAttributeIcon";
import { DreamAttributeIconBasic } from "../../DreamAttributeIcon/DreamAttributeIconBasic";
import IDream from "motw_core/Entity/IDream";
import { ArrayUtils } from "../../../../../services/ArrayUtils";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "../../../../Shared/Styles/CSS";

export function SelectDreamAttribute({
    dream,
    onChange,
}: {
    dream: IDream;
    onChange: (newDreamAttributes: string[]) => void;
}) {
    const label = dream.attributes.length > 1 ? `Add attribute` : `Attribute`;

    return (
        <div>
            <FormSelect
                id="selectAttributes"
                label={label}
                width="140px"
                suggestions={attributeMap.map(
                    (elem) => EDA[elem.attribute]
                )}
                onChange={(event) => {
                    const newDreamAttributes = GetNewDreamAttributes(
                        dream,
                        event
                    );

                    onChange(newDreamAttributes);
                }}
                value={dream.attributes.length === 1 ? dream.attributes[0] : ""}
            />
            <DreamAttributeIcons dream={dream} showAllIcons={false} />
            <DreamAttributeMultiSelector
                dreamAttributes={dream.attributes}
                {...{ onChange }}
            />
        </div>
    );
}

function GetNewDreamAttributes(
    dream: IDream,
    event: React.ChangeEvent<HTMLSelectElement>
) {
    if (event.target.value === "") {
        return [];
    }

    return ArrayUtils.AddToWithoutRepeating(
        dream.attributes,
        event.target.value
    );
}

function DreamAttributeMultiSelector({
    dreamAttributes,
    onChange,
}: {
    dreamAttributes: string[];
    onChange: (newDreamAttributes: string[]) => void;
}) {
    if (dreamAttributes.length <= 1) {
        return null;
    }

    return (
        <div>
            {dreamAttributes.map((attribute) => (
                <DreamAttributeItem
                    {...{
                        dreamAttributes,
                        attribute,
                        onChange,
                    }}
                />
            ))}
        </div>
    );
}

function DreamAttributeItem({
    dreamAttributes,
    attribute,
    onChange,
}: {
    dreamAttributes: string[];
    attribute: string;
    onChange: (newDreamAttributes: string[]) => void;
}) {
    return (
        <div style={{ margin: `10px` }}>
            <span>{attribute}</span>
            <DreamAttributeIconBasic {...{ attribute }} />
            <RemovEDA
                {...{ dreamAttributes, attribute, onChange }}
            />
        </div>
    );
}

function RemovEDA({
    dreamAttributes,
    attribute,
    onChange,
}: {
    dreamAttributes: string[];
    attribute: string;
    onChange: (newDreamAttributes: string[]) => void;
}) {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.remove}
            displayAsBlock={false}
            withClass={StyleClass(`DreamAttributeItem_removeLink`, {
                marginLeft: `5px`,
                opacity: 0.6,
            })}
            whenClicked={() => {
                const newDreamAttributes = ArrayUtils.Exclude(
                    dreamAttributes,
                    attribute
                );
                onChange(newDreamAttributes);
            }}
            tooltip="Remove this attribute"
        />
    );
}
